/* eslint-disable no-empty */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';

// Create (POST)
export const createData = createAsyncThunk('create data', async (newData) => {
  const response = await $axios.post('/gtm', newData);
  return response.data;
});

// Read (GET)
export const fetchData = createAsyncThunk('get data', async () => {
  const response = await $axios.get('/gtm');
  return response.data;
});

// // Single data (GET)
// export const fetchSingleData = createAsyncThunk('get single data', async (id) => {
//   const response = await $axios.get(`/gtm/${id}`);
//   return response.data;
// });

// Update (PUT or PATCH)
export const updateData = createAsyncThunk('update data', async ({ id, updatedData }) => {
  const response = await $axios.put(`/gtm/${id}`, updatedData);
  return response.data;
});

// Delete (DELETE)
export const deleteData = createAsyncThunk('delete data', async (id) => {
  await $axios.delete(`/gtm/${id}`);
  return id;
});

export const resetDataGtmSlice = createAsyncThunk('reset data', async () => {
  return 'reset data';
});

// Slice
const gtmSlice = createSlice({
  name: 'gtmSlice',
  initialState: {
    data: [],
    newGtm: null,
    newGtmError: false,
    singleGtm: null,
    singleGtmError: false,
    updatedGtm: null,
    updatedGtmError: false,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Fetch Data
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder.addCase(resetDataGtmSlice.fulfilled, (state) => {
      state.data = [];
      state.newGtm = null;
      state.newGtmError = false;
      state.singleGtm = null;
      state.singleGtmError = false;
      state.updatedGtm = null;
      state.updatedGtmError = false;
      state.loading = false;
      state.error = null;
    });

    // Fetch Single Data
    // builder
    //   .addCase(fetchSingleData.pending, (state) => {
    //     state.singleGtmError = false;
    //     state.loading = true;
    //     state.singleGtm = null;
    //   })
    //   .addCase(fetchSingleData.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.singleGtm = action.payload.data;
    //   })
    //   .addCase(fetchSingleData.rejected, (state, action) => {
    //     state.loading = false;
    //     state.singleGtm = null;
    //     state.singleGtmError = action.error;
    //   });

    // Create Data
    builder
      .addCase(createData.pending, (state) => {
        state.newGtmError = false;
        state.newGtm = null;
      })
      .addCase(createData.fulfilled, (state, action) => {
        state.newGtm = action.payload;
      })
      .addCase(createData.rejected, (state) => {
        state.newGtm = null;
        state.newGtmError = true;
      });

    // Update Data
    builder
      .addCase(updateData.pending, (state) => {
        state.updatedGtmError = false;
        state.loading = true;
        state.updatedGtm = null;
      })
      .addCase(updateData.fulfilled, (state, action) => {
        state.loading = false;
        state.updatedGtm = action.payload.data;
      })
      .addCase(updateData.rejected, (state, action) => {
        state.loading = false;
        state.updatedGtm = null;
        state.updatedGtmError = action.error;
      });

    // Delete Data
    builder.addCase(deleteData.fulfilled, (state, action) => {
      if (Array.isArray(state.data)) {
        state.data = state.data.filter((item) => item._id !== action.payload);
      }
    });
  },
});

export default gtmSlice.reducer;
